import axios from "axios";

export const controlEventTemplateApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND}api/control-event-template`,
  headers: {
    "Content-Type": "application/json",
  },
});
